module.exports = __webpack_public_path__ + "static/media/LIO_Imagery.67632e08.png";